import { render, staticRenderFns } from "./Scopes.vue?vue&type=template&id=182006be&"
import script from "./Scopes.vue?vue&type=script&lang=ts&"
export * from "./Scopes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports